import { CheckCircle2, Palette, Settings2, Sparkles } from "lucide-react";

export default function StepProgress({ step }) {
    const items = [
        {
            title: "Business Details",
            subtitle: "Define the business",
            icon: Settings2
        },
        {
            title: "Theme Selection",
            subtitle: "Choose the visual style",
            icon: Palette
        },
        {
            title: "Review & Actions",
            subtitle: "Preview and publish",
            icon: Sparkles
        }
    ];

    return (
        <div className="wg-step-progress">
            {items.map((item, index) => {
                const current = index + 1;
                const Icon = item.icon;
                const isActive = step === current;
                const isCompleted = step > current;

                return (
                    <div
                        key={item.title}
                        className={`wg-step-item ${isActive ? "active" : ""} ${isCompleted ? "completed" : ""}`}
                    >
                        <div className="wg-step-top">
                            <div className="wg-step-number">
                                {isCompleted ? <CheckCircle2 size={18} /> : current}
                            </div>

                            <div className="wg-step-copy">
                                <div className="wg-step-title-row">
                                    <div className="wg-step-title">{item.title}</div>
                                    <div className="wg-step-icon">
                                        <Icon size={16} />
                                    </div>
                                </div>
                                <div className="wg-step-subtitle">{item.subtitle}</div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}